module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Medium.0c8ea423.woff";